import { Component, ErrorInfo, ReactNode } from 'react';

import { LogLevel, Logger } from '@suntex.core/logging';

const logger = Logger.for(['ErrorBoundary'], { level: LogLevel.Warn });

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Generic error boundary that catches render errors and displays a fallback UI
 */
export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.error(
      'Error caught by ErrorBoundary:',
      () => ({ errorInfo }),
      error,
    );
  }

  public render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '100%',
              border: '1px dashed #ddd',
              borderRadius: '.25em',
              padding: '.25em',
              color: '#666',
            }}
          >
            Failed to load component. Please refresh the page.
          </div>
        )
      );
    }

    return this.props.children;
  }
}
